import * as React from 'react';

const SvgAshby = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      {...props}
    >
      <rect width="150" height="150" rx="20" fill="#473BCE" />
      <path
        d="M112.92 109.212C114.027 111.92 115.219 113.951 116.496 115.305C117.859 116.574 119.178 117.251 120.456 117.336V119.875C114.325 119.621 106.577 119.494 97.2112 119.494C87.5048 119.494 80.3527 119.621 75.7549 119.875V117.336C78.9904 117.167 81.2893 116.786 82.6516 116.194C84.0139 115.517 84.6951 114.374 84.6951 112.766C84.6951 111.243 84.1842 109.212 83.1625 106.673L75.6272 85.8545H49.8286L47.6574 91.5669C44.8477 98.7603 43.4428 104.261 43.4428 108.069C43.4428 111.539 44.4219 113.909 46.3803 115.178C48.3386 116.448 51.2335 117.167 55.0649 117.336V119.875C48.6791 119.621 43.1022 119.494 38.3341 119.494C34.3324 119.494 31.0543 119.621 28.5 119.875V117.336C30.6286 116.998 32.6295 115.686 34.5027 113.401C36.3758 111.116 38.2916 107.477 40.2499 102.484L68.6028 30C71.3275 30.1693 73.5838 30.2539 75.3718 30.2539C77.0747 30.2539 79.2884 30.1693 82.013 30L112.92 109.212ZM74.7332 83.3157L63.1111 51.5801L50.8503 83.3157H74.7332Z"
        fill="white"
      />
    </svg>
  );
};

export default SvgAshby;
